<script setup>
    import { useFormModalControlsStore } from '../stores/FormModalControls'
    import {storeToRefs} from "pinia"

    const formModalControls = useFormModalControlsStore(),
          { formModalVisible } = storeToRefs(formModalControls),
          { formModalClose } = formModalControls
</script>

<template>
	<dialog
		:class="{
			'fixed top-0 left-0 flex items-center justify-center bg-black w-full h-full max-w-[100vw] transition-all duration-500 px-4 py-4 z-50': true,
			'bg-opacity-0 pointer-events-none invisible': !formModalVisible,
			'bg-opacity-50 pointer-events-auto visible': formModalVisible
		}"
		:tabindex="formModalVisible ? '0' : '-1'"
		role="dialog"
		aria-modal="true"
	>
		<div class="absolute top-0 left-0 w-full h-full z-1" @click="formModalClose()" />
		<div
			:class="{
				'relative bg-white rounded-md shadow-2xl w-full max-w-[100vw] xl:max-w-[800px] p-4 md:p-6 lg:p-8 transition-all duration-500 z-50': true,
				'opacity-0 translate-y-10': !formModalVisible,
				'opacity-100 translate-y-0': formModalVisible
			}"
		>
			<header class="block mb-4 flex justify-between">
                <div class="flex items-center">
				    <slot name="title" />
                </div>
                <button type="button" class="theme-button self-start" @click="formModalClose()">
                    Close
                </button>
			</header>
			<slot />
		</div>
	</dialog>
</template>
